module.exports = __webpack_public_path__ + "pigmentace_1_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/dermatologie/pigmentace_1_before.jpg
// module id = 970
// module chunks = 0